import { Button, Dropdown } from 'antd';
import { ItemType } from 'antd/es/menu/interface';
import { ThreeDots } from 'assets';
import { messages } from 'messages';
import { ReasonDto } from 'types';

type ReasonActionProps = {
  reason: ReasonDto;
  onDelete?: (reason: ReasonDto) => void;
  onUpdateStatus?: (reason: ReasonDto) => void;
};

const ReasonActions = ({ reason, onDelete, onUpdateStatus }: ReasonActionProps) => {
  const actionItems: ItemType[] = [
    {
      key: 'updateStatus',
      label: messages.updateStatus
    },
    {
      key: 'delete',
      danger: true,
      label: messages.deleteButtonText
    }
  ];

  const onClickActionItem = (action: string, data: ReasonDto) => {
    switch (action) {
      case 'updateStatus':
        onUpdateStatus?.(data);
        break;
      case 'delete':
        onDelete?.(data);
        break;
    }
  };

  return (
    <>
      <Dropdown
        trigger={['click']}
        menu={{
          items: actionItems,
          onClick: ({ key }) => {
            onClickActionItem(key, reason);
          }
        }}
      >
        <Button type='text' shape='circle'>
          <ThreeDots />
        </Button>
      </Dropdown>
    </>
  );
};

export default ReasonActions;
